import { Button, Link, Stack, Typography } from "@mui/material";
import { ArrowRight, CalendarX, HouseLine } from "@phosphor-icons/react";
import { useHistory } from "react-router-dom";
import React from "react";

export const STEPS = {
  makeupDay: "makeupDay",
  recommendations: "recommendations",
  customDate: "customDate",
  review: "review",
  confirmation: "confirmation",
  rescheduleConfirmation: "rescheduleConfirmation",
  cancellationReview: "cancellationReview",
  cancellationConfirmation: "cancellationConfirmation",
  rescheduleWindowClosed: "rescheduleWindowClosed",
  noAppointments: "noAppointments",
};

export const GoHomePrimary = () => {
  const history = useHistory();
  return (
    <Button
      size="large"
      startIcon={<HouseLine weight="duotone" />}
      onClick={() => history.push("/dashboard")}
    >
      Go Home
    </Button>
  );
};

export const LinkAndCancelButton = ({ LinkLabel, onClickLink, onCancel }) => {
  return (
    <>
      <Link underline="none" onClick={onClickLink}>
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="body1">{LinkLabel}</Typography>
          <ArrowRight size={20} />
        </Stack>
      </Link>
      <Button
        size="large"
        color="error"
        variant="text"
        startIcon={<CalendarX />}
        onClick={onCancel}
      >
        Cancel Appointment
      </Button>
    </>
  );
};
